module.exports = __webpack_public_path__ + "img/1513808970.01ab3620.jpg";